module.exports = __webpack_public_path__ + "static/media/mongodb.633c1cfb.svg";